"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindsweptEffectHandler = exports.WindsweptEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Death_1 = require("./Death");
class WindsweptEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Windswept;
        this.__typeName = "Windswept";
        this.name = "Windswept";
        this.harmful = true;
    }
}
exports.WindsweptEffectArgs = WindsweptEffectArgs;
WindsweptEffectArgs.CustomText = "It's going to be a long fall.";
let WindsweptEffectHandler = class WindsweptEffectHandler {
    apply(sequence, container, state) {
        if (container.getEffectsOfType(state.targetId, EffectType_1.EffectType.Windswept).length > 1) {
            container.applyEffect(sequence, state.creatorId, state.targetId, new Death_1.DeathEffectArgs(), Duration_1.Duration.Permanent, true);
        }
    }
    remove(sequence, container, state) {
    }
};
WindsweptEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Windswept)
], WindsweptEffectHandler);
exports.WindsweptEffectHandler = WindsweptEffectHandler;
